import React, { useEffect, useRef, useState } from "react";
// import { useHistory } from "react-router-dom";
import { Link, useNavigate, Navigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import useSound from "use-sound";
import { EmailField, PasswordField } from "./Login.style";
import "../../../Styles/authentication.css";
import "../../../Styles/typography.css";

import { ReactComponent as HeaderLogo } from "../../../Assets/Images/LandingPage/subjects-master-logo.svg";
import { ReactComponent as ButtonArrow } from "../../../Assets/Images/Button/btn_arrow.svg";
import { ReactComponent as FacebookIcon } from "../../../Assets/Images/Header/Facebook.svg";
import { ReactComponent as InstaIcon } from "../../../Assets/Images/Header/Instagram.svg";
import { ReactComponent as TiktokIcon } from "../../../Assets/Images/Header/TikTok.svg";
import { SOCIAL_MEDIA_LINKS } from "Helpers";

import { InputAdornment, IconButton, Typography, InputLabel, Box } from "@material-ui/core";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import Visibility from "@material-ui/icons/Visibility";
import MobileHeader from "Components/Header/MobileHeader";

// FORM VALIDATION
import { useFormik } from "formik";
import * as Yup from "yup";

// STYLES
// import { PageWrapper, LoginBox, EmailField, PasswordField, SignInButton } from "./Login.style";

// CONST
import { Api, CODES, URL_REGISTER, URL_FRGT_PWD, generateValidationSchema, URL_GENERAL_DASHBOARD } from "Helpers";
import { loginUser, updateProfileInfo, updateStorage, subjectAccessData } from "Redux/Auth/Actions";
import { showToast } from "Redux/General/Actions";

// SOUNDS
import LoginSound from "Assets/Sounds/login-sound.mp3";
import CustomButton from "Components/Commons/CustomButton/CustomButton";
import CaptchaWidget from "Components/Commons/Captcha/CaptchaWidget";
import { captchaHeaders } from "Helpers/captcha";

function Login() {
	const [isLoading, setIsLoading] = useState(false);
	const [values, setValues] = useState({
		password: "",
		showPassword: false,
	});

	const [play] = useSound(LoginSound, { volume: 0.2 });
	const captchaRef = useRef(null);

	// REDUX
	const isLoggedIn = useSelector((state) => state.Auth.isLoggedIn);
	const dispatch = useDispatch();

	// ROUTER
	const navigate = useNavigate();

	//form
	const formik = useFormik({
		initialValues: {
			password: "",
			email: "",
		},
		validationSchema: Yup.object({
			email: Yup.string().required("*Please enter your email address.").email("Ex user@mail.com"),
			password: Yup.string().trim().required("*Please enter your password ").min(6, "Password must be atleast 6 length"),
		}),
		onSubmit: (values) => {
			handleLogin(values);
		},
	});

	const handleClickShowPassword = () => {
		setValues({ ...values, showPassword: !values.showPassword });
	};

	const handleMouseDownPassword = (event) => {
		event.preventDefault();
	};

	async function handleLogin(values) {
		setIsLoading(true);

		let captchaToken = null;
		try {
			captchaToken = await captchaRef.current?.getToken();
		} catch (captchaError) {
			dispatch(showToast(captchaError.message));
			setIsLoading(false);
			return;
		}

		new Api()
			.post("user/login", { data: values, headers: captchaHeaders(captchaToken), returnError: true })
			.then(async (response) => {
				if (response.status === 200 || response.status === 201) {
					let data = {
						accessToken: response.data.accessToken,
						role: response?.data?.role ? response.data.role : "",
					};
					let subject = { data: response?.data?.subjectAccessData && response.data.subjectAccessData.length ? response.data.subjectAccessData : [] };

					// UPDATE LOCAL STORAGE
					updateStorage(data);

					// GET PROFILE INFO
					let profileInfo = await new Api().get("user/profile");

					dispatch(loginUser(data));
					dispatch(updateProfileInfo(profileInfo.data));
					dispatch(subjectAccessData(subject));
					setIsLoading(false);
					play();
					navigate(URL_GENERAL_DASHBOARD, { replace: true });
				} else {
					dispatch(showToast(response.data.message || "invalid email / password"));
					setIsLoading(false);
				}
			})
			.catch((error) => {
				if (error.status === CODES.UNAUTHORIZED) dispatch(showToast(error.data.message || "invalid email / password"));
				setIsLoading(false);
			})
			.finally(() => captchaRef.current?.reset());
	}

	// All hooks done — safe to return early now
	if (isLoggedIn) return <Navigate to={URL_GENERAL_DASHBOARD} replace />;

	return (
		<div className="login-regi-wrapper">
			<div className="auth-wrap-left">
				<div className="auth_wrap_logo">
					<MobileHeader></MobileHeader>
					<Link to="/" className="desktop_logo_login">
						<HeaderLogo></HeaderLogo>
					</Link>
				</div>
				<div className="auth_wrap_left_in">
					<h1>
						Welcome to <br /> <span className="redfont">Subjects Master</span>
					</h1>
					<p>
						Explore interactive games, quizzes, and activities that turn learning into an adventure. Discover new topics, challenge yourself, and test your knowledge, all while having fun!
					</p>
				</div>
			</div>
			<div className="auth_wrap_right">
				<div className="">
					<div className="menu_other_buttons">
						<div className="social_handles">
							<ul>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.FACEBOOK} target="_blank" rel="noopener noreferrer">
										<FacebookIcon />
									</a>
								</li>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.INSTAGRAM} target="_blank" rel="noopener noreferrer">
										<InstaIcon />
									</a>
								</li>
								<li>
									<a href={SOCIAL_MEDIA_LINKS.TIKTOK} target="_blank" rel="noopener noreferrer">
										<TiktokIcon />
									</a>
								</li>
							</ul>
						</div>

						<div className='portal_login_link'>
							<Link to='/teacher/login'>Portal Login</Link>
						</div>
						<div className='logins_btn'>
							<Link to='/register' className='customs_btn'>Register <span><ButtonArrow /></span></Link>
						</div>
					</div>
				</div>
				<div className="auth_right_inner">
					<div className="auth_right_head">
						<h2>Login</h2>
						<h4 className="redfont">Your Adventure in Learning Starts Here</h4>
					</div>
					<form onSubmit={formik.handleSubmit} validationSchema={validationSchema}>
						<Box className="content">
							<Box className="header">
								<InputLabel className="header"></InputLabel>
							</Box>
							<Box>
								<Box className="flex-column-parent">
									<Box className="flex-column field_wrapper">
										<Box component="Box" sx={{ display: "inline" }} className="text">
											<InputLabel className="text">Email address</InputLabel>
										</Box>

										<EmailField
											id="email"
											name="email"
											className="login"
											autoComplete="false"
											onBlur={formik.handleBlur}
											onChange={formik.handleChange}
											defaultValue={formik.values.email}
											placeholder="Enter email address"
											helpertext={formik.touched.email && formik.errors.email}
										/>
										<Box component="div" sx={{ display: "inline", height: "10px" }} className="validation-error text">
											{formik.touched.email && formik.errors.email ? formik.errors.email : ""}
										</Box>
									</Box>

									<Box className="flex-column field_wrapper">
										<Box component="div" sx={{ display: "inline" }} className="text">
											<InputLabel className="text">Password</InputLabel>
										</Box>

										<PasswordField
											placeholder="Enter password"
											name="password"
											key="password"
											className="login"
											value={formik.values.password}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											type={values.showPassword ? "text" : "password"}
											endAdornment={
												<InputAdornment position="end" name="password" key="password">
													<IconButton
														aria-label="toggle password visibility"
														onClick={handleClickShowPassword}
														onMouseDown={handleMouseDownPassword}
														className="paswword-icon"
													>
														{values.showPassword ? <Visibility /> : <VisibilityOff />}
													</IconButton>
												</InputAdornment>
											}
										/>
										<Box component="div" sx={{ display: "inline", height: "10px" }} className="validation-error text">
											{formik.touched.password && formik.errors.password ? formik.errors.password : ""}
										</Box>
									</Box>
								</Box>

								<Box className="remember-me-parent">
									{/* <Box className="flex-center" style={{ visibility: "Hidden" }}>
										<Checkbox className="checkbox" />
										<Typography className="remember-me-font">Remember me</Typography>
									</Box> */}

									<Box className="forgot-password-parent">
										<Typography className="forgot-password">
											<Link to={URL_FRGT_PWD}>Forgot Password?</Link>
										</Typography>
									</Box>
								</Box>
							</Box>
							<CaptchaWidget ref={captchaRef} action="login" />
							<div className="login_btn_divs">
								<Box className="login-button-parent">
									{/* <Button className="button customs_btn" type="submit" endIcon={isLoading ? <CircularProgress className="loader" /> : ""}>
										Login
									</Button> */}
									<CustomButton text={isLoading ? "Loading..." : "Login"} className="button" type="submit" isLoading={isLoading} />
								</Box>

								<Box className="model-footer ac_info_foter">
									<Typography className="font dose-not-have-account-font">Don't have an account yet?</Typography>
									<Typography className="font register-as-school-font">
										<Link to={URL_REGISTER}>Register Now</Link>
									</Typography>
								</Box>
							</div>
						</Box>
					</form>
				</div>
			</div>
		</div>
	);
}

export default Login;

const inputs = [
	{
		label: "Email",
		name: "email",
		validation: { required: true, email: true },
	},
	{
		label: "Password",
		name: "password",
		type: "password",
		validation: { required: true, min: 6 },
	},
];

const validationSchema = generateValidationSchema(inputs);
